import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    SpecialPricingLogReportItem,
    SpecialPricingReportRequestData,
    SpecialPricingSummaryReportItem,
} from "../../../../graphql/types"

export const fetchSpecialPricingLogReport = (
    headers: Record<string, any>,
    data: SpecialPricingReportRequestData
): Promise<SpecialPricingLogReportItem[]> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query specialPricingLogReport($data: SpecialPricingReportRequestData!) {
                  specialPricingLogReport(data: $data) {
                    id
                    originTimestamp
                    orderNumber
                    assigneeName
                    adminName
                    terminalName
                    pricingName
                    percentage
                    type
                    total
                  }
                }
            `,
            operationName: "specialPricingLogReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.specialPricingLogReport) {
            return response.data.specialPricingLogReport
        }

        return []
    })

export const fetchSpecialPricingSummaryReport = (
    headers: Record<string, any>,
    data: SpecialPricingReportRequestData
): Promise<SpecialPricingSummaryReportItem[]> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query specialPricingSummaryReport($data: SpecialPricingReportRequestData!) {
                  specialPricingSummaryReport(data: $data) {
                      ...SpecialPricingSummaryReportData
                      children {
                        ...SpecialPricingSummaryReportData
                        children {
                          ...SpecialPricingSummaryReportData
                          children {
                              ...SpecialPricingSummaryReportData   
                            }
                        }
                      }
                  }
                }
               
                fragment SpecialPricingSummaryReportData on SpecialPricingSummaryReportItem {
                    name
                    count
                    total
                    percentage
                    absolute
                }
    
            `,
            operationName: "specialPricingSummaryReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.specialPricingSummaryReport) {
            return response.data.specialPricingSummaryReport
        }

        return []
    })

export const fetchSpecialPricingByEmployeeReport = (
    headers: Record<string, any>,
    data: SpecialPricingReportRequestData
): Promise<SpecialPricingSummaryReportItem[]> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query specialPricingByEmployeeReport($data: SpecialPricingReportRequestData!) {
                  specialPricingByEmployeeReport(data: $data) {
                      ...SpecialPricingSummaryReportData
                      children {
                        ...SpecialPricingSummaryReportData
                        children {
                          ...SpecialPricingSummaryReportData
                          children {
                            ...SpecialPricingSummaryReportData
                            children {
                              ...SpecialPricingSummaryReportData   
                            }
                          }
                        }
                      }
                  }
                }
               
                fragment SpecialPricingSummaryReportData on SpecialPricingSummaryReportItem {
                    name
                    count
                    total
                    percentage
                    absolute
                }
    
            `,
            operationName: "specialPricingByEmployeeReport",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.specialPricingByEmployeeReport) {
            return response.data.specialPricingByEmployeeReport
        }

        return []
    })
